import React from 'react'

import FormattedDate from '../../components/FormattedDate'
import styles from './EnrollmentDates.css'
import { FormattedMessage } from 'react-intl'

const EnrollmentDates = props => {
  const {
    enrollment,
    dateFormat,
    me,
  } = props

  const content = []
  const hasStartAndEnd = enrollment && enrollment.startDate && enrollment.endDate
  const hasStartOnly = enrollment && enrollment.startDate && !enrollment.endDate
  const hasNoDates = enrollment && !enrollment.startDate && !enrollment.endDate

  if (!enrollment || hasNoDates) {
    content.push('-')
  }

  if (hasStartAndEnd) {
    content.push((
      <span key={1}>
        <FormattedDate
          date={enrollment.startDate}
          fmt={dateFormat}
          me={me}
        /> to&nbsp;
        <FormattedDate
          date={enrollment.endDate}
          fmt={dateFormat}
          me={me}
        />
      </span>
    ))
  }

  if (hasStartOnly) {
    content.push((
      <span key={2}>
        <FormattedDate
          date={enrollment.startDate}
          fmt={dateFormat}
          me={me}
        /> <FormattedMessage id="label.to_no_end_date" />
      </span>
    ))
  }
  return content
}

export default EnrollmentDates



// WEBPACK FOOTER //
// ./src/legacy/components/EnrollmentDates/EnrollmentDates.jsx